import { z } from "zod";

export enum Flag {
  OutageBanner = "outage_banner",
  TestingSDK = "testing_sdk",
}
export const FlagEnum = z.nativeEnum(Flag);

export const flagSchemaMap = z.object({
  [Flag.OutageBanner]: z.object({
    enabled: z.boolean(),
    message: z.string(),
  }),
  [Flag.TestingSDK]: z.boolean(),
});
export type FlagTypes = z.infer<typeof flagSchemaMap>;

export const FLAG_DEFAULTS: FlagTypes = {
  [Flag.OutageBanner]: { enabled: false, message: "" },
  [Flag.TestingSDK]: false,
};
